const services = [
  "Change of Nomination",
  "Registering new Nominee Name",
  "Change of Address",
  "Issuance of Duplicate Policy",
  "Revival of Lapsed Policy",
  "Non-receipt of the Survival Benefit Amount",
  "Non-receipt of the Maturity Amount",
  "Transferring Policy Records between Branches",
  "Loan Against Policy",
  "Death Claim",
];

export default services;
